/**
 * Copyright (c) 2018-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import AppDispatcher from '../../core/AppDispatcher'
import { appActions } from '../AppActions'
import ApiHandle from '../../util/ApiHandle'
import ApiClient from '../../ApiClient'
import MailApi from '../../api/MailApi'
import history from '../../util/history'

export const SmtpSettingActionTypes = {
  initialize: 'mail/smtp_setting/initialize',
  fetchAll: 'mail/smtp_setting/fetch-all',
  fetchOne: 'mail/smtp_setting/fetch-one',
  onCreate: 'mail/smtp_setting/on-create',
  onEdit: 'mail/smtp_setting/on-edit',
  onUpdate: 'mail/smtp_setting/on-update',
  onCancel: 'mail/smtp_setting/on-cancel'
}

const mailApi = new MailApi(ApiClient.instance)

const SmtpSettingActions = {
  onInit: () => {
    AppDispatcher.dispatchWithType(SmtpSettingActionTypes.initialize)
  },

  onCreate: () => {
    AppDispatcher.dispatchWithType(SmtpSettingActionTypes.onCreate)
    history.push(`/mail/smtp_settings/new`)
  },

  onUpdate: smtp_setting => {
    history.push(`/mail/smtp_settings/${smtp_setting.id}/edit`)
  },

  onEdit: event => {
    AppDispatcher.dispatchWithType(SmtpSettingActionTypes.onEdit, {
      name: event.target.name,
      value: event.target.value
    })
  },

  onCancel: event => {
    history.push(`/mail/smtp_settings`)
  },

  fetchOne: smtpSettingId => {
    const apiHandleOpts = {
      apiCall: () => mailApi.getSmtpSetting(smtpSettingId),
      onSucceded: response => {
        AppDispatcher.dispatchWithType(SmtpSettingActionTypes.fetchOne, response)
      },
      onFailed: response => {
        appActions.snackbar('取得できませんでした', 'error', true)
      },
      onErrored: error => {
        const e = JSON.parse(error.response.text)
        e.columns.forEach(column => appActions.snackbar(column, 'error', true))
      }
    }
    ApiHandle(apiHandleOpts)
  },

  fetchAll: () => {
    const apiHandleOpts = {
      apiCall: () => mailApi.getSmtpSettings(),
      onSucceded: response => {
        AppDispatcher.dispatchWithType(SmtpSettingActionTypes.fetchAll, { smtp_settings: response })
      },
      onFailed: response => {
        appActions.snackbar('取得できませんでした', 'error', true)
      },
      onErrored: error => {
        const e = JSON.parse(error.response.text)
        e.columns.forEach(column => appActions.snackbar(column, 'error', true))
      }
    }
    ApiHandle(apiHandleOpts)
  },

  onRequestCreate: smtpSetting => {
    const body = { smtp_setting: smtpSetting }
    const apiHandleOpts = {
      apiCall: () => mailApi.createSmtpSetting(body),
      onSucceded: response => {
        SmtpSettingActions.onCancel()
        appActions.snackbar('保存しました', 'success', true)
      },
      onFailed: response => {
        appActions.snackbar('保存に失敗しました', 'error', true)
      },
      onErrored: error => {
        const e = JSON.parse(error.response.text)
        e.columns.forEach(column => appActions.snackbar(column, 'error', true))
      }
    }
    ApiHandle(apiHandleOpts)
  },

  onRequestUpdate: smtpSetting => {
    const smtpSettingId = smtpSetting.id
    const body = { smtp_setting: smtpSetting }
    const apiHandleOpts = {
      apiCall: () => mailApi.updateSmtpSetting(smtpSettingId, body),
      onSucceded: response => {
        SmtpSettingActions.onCancel()
        appActions.snackbar('保存しました', 'success', true)
      },
      onFailed: response => {
        appActions.snackbar('保存に失敗しました', 'error', true)
      },
      onErrored: error => {
        const e = JSON.parse(error.response.text)
        e.columns.forEach(column => appActions.snackbar(column, 'error', true))
      }
    }
    ApiHandle(apiHandleOpts)
  },

  onRequestDelete: SmtpSettingId => {
    const apiHandleOpts = {
      apiCall: () => mailApi.deleteSmtpSetting(SmtpSettingId),
      onSucceded: response => {
        history.push('/mail/smtp_settings')
        appActions.snackbar('削除しました', 'success', true)
      },
      onFailed: response => {
        appActions.snackbar('削除に失敗しました', 'error', true)
      },
      onErrored: error => {
        const e = JSON.parse(error.response.text)
        e.columns.forEach(column => appActions.snackbar(column, 'error', true))
      }
    }
    ApiHandle(apiHandleOpts)
  }
}

export default SmtpSettingActions
